export const productsData = [
    {
        id: 1,
        name: "Ngọc trai",
        price: 700000,
        image: "/images/products/day-chuyen/ngoc-trai-700k.png",
        category: "Dây chuyền",
        stock: 9,
        bestseller: true
    },
    {
        id: 2,
        name: "Ngọc tụ nham",
        price: 800000,
        image: "/images/products/vong-da-cao-cap/ngoc-tu-nham-800k.png",
        category: "Vòng đá cao cấp",
        stock: 5,
        bestseller: true
    },
    {
        id: 3,
        name: "Thạch anh hồ ly",
        price: 329000,
        image: "/images/products/vong-da-thiet-ke/thach-anh-ho-ly-329k.jpg",
        category: "Vòng đá thiết kế",
        stock: 6,
        bestseller: true
    },
    {
        id: 4,
        name: "Thạch anh mắt mèo đuôi reo",
        price: 249000,
        image: "/images/products/vong-da-thiet-ke/thach-anh-mat-meo-duoi-reo-249k.png",
        category: "Vòng đá thiết kế",
        stock: 4,
        bestseller: true
    },
    {
        id: 5,
        name: "Vòng tay khóa vỏ sò trắng",
        price: 269000,
        image: "/images/products/vong-da-thiet-ke/vong-tay-khoa-vo-so-trang-269k.png",
        category: "Vòng đá thiết kế",
        stock: 3
    },
    {
        id: 6,
        name: "Vòng thạch anh 7 hành tinh",
        price: 249000,
        image: "/images/products/vong-da-thiet-ke/vong-thach-anh-7-hanh-tinh-249k.jpg",
        category: "Vòng đá thiết kế",
        stock: 8
    },
];